exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__ModalForm___2kwlU{z-index:1000 !important}", ""]);

// Exports
exports.locals = {
	"ModalForm": "styles__ModalForm___2kwlU"
};